var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("organizational-structure-menu"),
      _c("h1", [
        _vm._v(_vm._s(_vm.$t("settings.organisationStructure.title")))
      ]),
      _c("v-alert", { attrs: { type: "info" } }, [
        _vm._v(
          " " + _vm._s(_vm.$t("settings.organisationStructure.alertInfo")) + " "
        )
      ]),
      _c("v-treeview", {
        staticClass: "mt-3",
        attrs: {
          items: _vm.items,
          "item-key": "name",
          "item-text": "",
          "open-all": "",
          "open-on-click": ""
        },
        scopedSlots: _vm._u([
          {
            key: "prepend",
            fn: function(ref) {
              var item = ref.item
              var open = ref.open
              var leaf = ref.leaf
              return [
                _c(
                  "v-row",
                  {
                    on: {
                      contextmenu: function(v) {
                        _vm.showContextMenu(v, item, leaf)
                      }
                    }
                  },
                  [
                    _c("v-icon", [
                      _vm._v(
                        " " +
                          _vm._s(
                            open ? "mdi-folder-open" : "mdi-folder-account"
                          ) +
                          " "
                      )
                    ]),
                    _c(
                      "v-col",
                      [
                        _c(
                          "span",
                          { staticClass: "ml-2 font-weight-bold title" },
                          [_vm._v(_vm._s(item.name) + " ")]
                        ),
                        _vm._v(" (" + _vm._s(item.count_users) + " "),
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v("people")
                        ]),
                        _vm._v(" ) ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px", persistent: "" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("settings.organisationStructure.dialog.headline")
                    )
                  )
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.formValid,
                        callback: function($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid"
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label:
                            _vm.$t(
                              "settings.organisationStructure.dialog.fields.name.name"
                            ) + "*",
                          rules: [_vm.isRequiredValidation]
                        },
                        model: {
                          value: _vm.currentItem.name,
                          callback: function($$v) {
                            _vm.$set(_vm.currentItem, "name", $$v)
                          },
                          expression: "currentItem.name"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label:
                            _vm.$t(
                              "settings.organisationStructure.dialog.fields.description.name"
                            ) + "*",
                          rules: [_vm.isRequiredValidation]
                        },
                        model: {
                          value: _vm.currentItem.description,
                          callback: function($$v) {
                            _vm.$set(_vm.currentItem, "description", $$v)
                          },
                          expression: "currentItem.description"
                        }
                      }),
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            disabled: _vm.currentItem.children.length === 0,
                            bottom: ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "v-select",
                                    _vm._g(
                                      {
                                        attrs: {
                                          disabled:
                                            _vm.currentItem.children.length > 0,
                                          items: _vm.availableParents,
                                          "item-text": "name",
                                          "item-value": "id",
                                          label: _vm.$t(
                                            "settings.organisationStructure.dialog.fields.parent.name"
                                          )
                                        },
                                        model: {
                                          value: _vm.currentItem.parent_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.currentItem,
                                              "parent_id",
                                              $$v
                                            )
                                          },
                                          expression: "currentItem.parent_id"
                                        }
                                      },
                                      on
                                    )
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "settings.organisationStructure.canNotChangeParentTooltip"
                                )
                              ) +
                              " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: !_vm.formValid,
                        color: "blue darken-1",
                        text: ""
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.save($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.save")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-menu",
        {
          attrs: {
            "position-x": _vm.x,
            "position-y": _vm.y,
            absolute: "",
            "offset-y": ""
          },
          model: {
            value: _vm.showMenu,
            callback: function($$v) {
              _vm.showMenu = $$v
            },
            expression: "showMenu"
          }
        },
        [
          _c(
            "v-list",
            [
              _c(
                "v-list-item",
                { on: { click: _vm.addNew } },
                [
                  _c("v-list-item-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "settings.organisationStructure.contextMenu.addNew"
                        )
                      )
                    )
                  ])
                ],
                1
              ),
              _c(
                "v-list-item",
                { on: { click: _vm.edit } },
                [
                  _c("v-list-item-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "settings.organisationStructure.contextMenu.edit"
                        )
                      )
                    )
                  ])
                ],
                1
              ),
              _c(
                "v-tooltip",
                {
                  attrs: {
                    bottom: "",
                    disabled: !(
                      _vm.currentItem.children.length !== 0 ||
                      _vm.currentItem.count_users !== 0 ||
                      _vm.currentItem.parent_id == null
                    )
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-list-item",
                            _vm._g(
                              {
                                attrs: {
                                  disabled:
                                    _vm.currentItem.children.length !== 0 ||
                                    _vm.currentItem.count_users !== 0 ||
                                    _vm.currentItem.parent_id == null
                                },
                                on: { click: _vm.remove }
                              },
                              on
                            ),
                            [
                              _c("v-list-item-title", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "settings.organisationStructure.contextMenu.delete"
                                    )
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.currentItem.parent_id === null
                          ? _vm.$t(
                              "settings.organisationStructure.canNotDeleteMainStructureTooltip"
                            )
                          : _vm.$t(
                              "settings.organisationStructure.canNotDeleteTooltip"
                            )
                      ) +
                      " "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }